<template>
  <div class="gift-details app-container">
    <div class="global-header-wrap">
      <h3>
        卡包活动详情
      </h3>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style">
          <a
            href="/static/docs/code.xlsx"
            download="卡号模板"
            target="_blank"
            >{{ $t("commonMsg.downLoadForecast") }}</a
          >
        </button>
        <button class="global-button-style" @click="addCode">
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :currentPage="params.page"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination :pageSize="params.limit" :total="total" @pageNum="pageNum" />
    </el-card>

    <!-- ============= 新增 & 编辑弹窗 =============== -->
    <el-dialog
      :title="title"
      :visible.sync="codeHandle"
      width="800px"
      center
      @close="closeDialog"
    >
      <div>
        <el-form
          label-width="80px"
          :model="gift"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <div v-if="title === '新增'">
            <el-form-item :label="'名称'">
              <span>{{ cardTitle }}</span>
            </el-form-item>
            <el-form-item :label="'礼品卡号'" v-if="userInfo.roleValue === 1">
              <div>
                <el-upload
                  class="fl"
                  action=""
                  :auto-upload="false"
                  :on-change="importGiftCard"
                  :show-file-list="false"
                  style="float: left"
                >
                  <span class="gift-mgt-fileName" v-if="codeFile">{{
                    codeFile.name
                  }}</span>
                  <el-button size="small" type="primary">导入</el-button>
                </el-upload>
                <span class="hand-add-btn fl" @click="toggleCode()"
                  >手动添加</span
                >
              </div>

              <ul class="parms-list" v-show="codesFlag">
                <li v-for="(item, index) in codes" :key="index">
                  <input
                    type="text"
                    v-model="item.code"
                    :id="item.id"
                    :ref="item.id"
                    placeholder="卡号"
                  />
                  <input
                    type="text"
                    class="mid"
                    v-model="item.password"
                    placeholder="密码"
                  />
                  <input
                    type="text"
                    class="last"
                    v-model="item.verifyCode"
                    placeholder="验证码"
                  />
                  <span
                    v-if="index === codes.length - 1"
                    @click="addParam"
                    title="添加项"
                    ><i class="el-icon-plus"></i
                  ></span>
                  <span
                    v-if="index > 0"
                    @click="deleteParam(codes, item.id)"
                    title="删除项"
                    ><i class="el-icon-minus"></i
                  ></span>
                </li>
              </ul>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item :label="'手机号码'">
              <el-input
                v-model="gift.phone"
                class="fl"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item :label="'礼品卡号'" v-if="userInfo.roleValue === 1">
              <el-input
                v-model="gift.code"
                class="fl"
                style="width: 100%"
              ></el-input>
            </el-form-item>

            <el-form-item :label="'密码'">
              <el-input
                v-model="gift.password"
                class="fl"
                style="width: 100%"
              ></el-input>
            </el-form-item>
            <el-form-item :label="'验证码'">
              <el-input
                v-model="gift.verifyCode"
                class="fl"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="codeHandle = false">取 消</el-button>
        <el-button type="primary" @click="codeEvn('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- ============= ============== =============== -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup", "userInfo"]),
    tableProps() {
      let tableProps = [
        {
          prop: "code",
          obj: true,
          label: "卡号"
        },
        {
          prop: "password",
          obj: true,
          label: "密码"
        },
        {
          prop: "verifyCode",
          label: "验证码"
        },
        {
          prop: "actived",
          label: "领取"
        },
        {
          prop: "card_detail_status",
          label: "状态"
        },
        {
          width: 200,
          prop: "cardDetailsHandle",
          label: this.$t("org.manage")
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      gift: {
        code: "",
        phone: "",
        password: "",
        verifyCode: ""
      },
      cardTitle: "",
      userFile: null,
      codeFile: null,
      params: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt",
        id: this.$route.query.id
      },
      codes: [],
      codesFlag: false,
      tableData: [],
      total: 0,
      title: "",
      giftCodeItem: null,
      codeHandle: false,
      rules: {}
    };
  },

  created() {},

  methods: {
    toggleCode() {
      this.codesFlag = !this.codesFlag;
      if (this.codesFlag) {
        this.codes = [
          {
            id: String(Math.random()).substring(2, 12),
            code: "",
            password: "",
            verifyCode: ""
          }
        ];
      } else {
        this.codes = [];
      }
    },
    addParam() {
      const obj = {
        id: String(Math.random()).substring(2, 12),
        code: "",
        password: "",
        verifyCode: ""
      };
      this.codes.push(obj);
    },

    deleteParam(arr, id) {
      arr.map((item, i) => {
        if (item.id === id) {
          arr.splice(i, 1);
        }
      });
    },

    importGiftCard(file) {
      let showCode = true;
      if (this.codes.length) {
        this.codes.map(item => {
          if (item.code.trim()) {
            showCode = false;
          }
        });
      }

      if (showCode) {
        // 隐藏手动添加的code项
        this.codesFlag = false;
      }

      this.codeFile = file;
    },
    importPhone(file) {
      this.userFile = file;
    },
    getList() {
      this.$http.getCardDetails(this.params).then(res => {
        this.tableData = res.data.results;
        this.cardTitle = res.data.cardHolder.title;
        this.total = res.data.count;
      });
    },

    addCode() {
      this.title = "新增";
      this.codeHandle = true;
    },

    codeEvn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.title === "新增") {
            this.create();
          } else {
            this.editCode();
          }
        } else {
          return false;
        }
      });
    },

    toGiftHistory(data) {
      this.$router.push({
        name: "historyCard",
        query: { id: data.row._id }
      });
    },

    edit(data) {
      this.giftCodeItem = data.row;
      this.gift.code = data.row.code;
      this.gift.phone = data.row.phone;
      this.gift.password = data.row.password;
      this.gift.verifyCode = data.row.verifyCode;
      this.title = "编辑";
      this.codeHandle = true;
    },

    create() {
      let params = {
        code: this.codeFile ? this.codeFile.raw : ""
      };
      params.title = this.cardTitle;

      let form = new FormData();
      let keys = Object.keys(params);
      keys.forEach(key => {
        form.append(key, params[key]);
      });

      let codes = [];
      let stop = true;
      this.codes.map(item => {
        if (item.code.trim() === "" && this.codes.length > 0) {
          this.elMsg("卡号不能为空", "warning");
          document.getElementById(item.id).focus();
          stop = false;
        }

        let obj = {
          code: item.code,
          password: item.password,
          verifyCode: item.verifyCode
        };
        codes.push(obj);
      });

      form.append("codes", JSON.stringify(codes));

      if (!stop) return;

      if (!form.get("code") && this.codes.length === 0) {
        // 没有导入礼品卡号时且没有手动填写卡号时，给出提示
        this.elMsg(this.$t("sale.card.importCard"), "warning");
        return;
      }

      this.$http.addCard(form).then(res => {
        this.codeHandle = false;
        form.append("code", "");
        this.codeFile = null;
        this.codesFlag = false;
        this.codes = [];

        if (res.data.sucessCount === 0) {
          this.elMsg(
            this.$t("sale.card.import") +
              this.$t("sale.card.success") +
              res.data.sucessCount +
              ", " +
              this.$t("sale.card.fail") +
              res.data.faildCount +
              this.$t("sale.card.item"),
            "warning"
          );
        } else {
          this.elMsg(
            this.$t("sale.card.import") +
              this.$t("sale.card.success") +
              res.data.sucessCount +
              ", " +
              this.$t("sale.card.fail") +
              res.data.faildCount +
              this.$t("sale.card.item"),
            "success"
          );
        }
        // this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.getList();
      });
    },

    editCode() {
      let params = {};
      params.phone = this.gift.phone;
      params.password = this.gift.password;
      params.verifyCode = this.gift.verifyCode;

      if (this.userInfo.roleValue === 1) {
        params.code = this.gift.code;
        if (params.code.trim() === "") {
          this.elMsg(this.$t("sale.card.inputCode"), "warning");
          return;
        }
      } else {
        delete params.code;
      }

      this.$http
        .updateGiftCode(this.giftCodeItem._id, params)
        .then(res => {
          this.codeHandle = false;
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },

    toDetails(data) {
      this.giftCodeItem = data.row;
    },

    recovery(data) {
      // 回收
      this.$http
        .recoveryGiftCode({ id: data.row._id })
        .then(res => {
          this.elMsg(this.$t("alertMsg.recoverySuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },

    del(data) {
      this.$http
        .delGiftCode(data.row._id)
        .then(res => {
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        })
        .catch(err => {
          this.elMsg(err.response.data.message, "error");
        });
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    },

    closeDialog() {
      this.codeFile = null;
      this.codes = [];
      this.codesFlag = false;
      for (let i in this.gift) {
        this.gift[i] = "";
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.gift-details-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.gift-details-pagination {
  padding: 10px;
  text-align: right;
}
.gift-import-btn {
  margin-top: 10px;
}
.gift-mgt-fileName {
  margin-right: 10px;
}
.hand-add-btn {
  background-color: #56a3fd;
  border-radius: 3px;
  padding: 0px 12px;
  margin-left: 10px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  &:hover {
    background-color: #5bbbff;
  }
}
</style>
